import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'FEED';
export const {
    action: fetch,
    success: fetchSuccess,
    failed: fetchFailed,
} = createAction(`${domain}/FETCH`, ({reload, olderThan, resolve, heightTarget, initialFetch}) => ({
    reload,
    olderThan,
    resolve,
    heightTarget,
    initialFetch,
}));

export const {action: clearState} = createAction(`${domain}/CLEAR_STATE`);

export const {
    action: updateAfterPhotoSwipeClose,
    success: updateAfterPhotoSwipeCloseSuccess,
    failed: updateAfterPhotoSwipeCloseFailed,
} = createAction(`${domain}/UPDATE_AFTER_PHOTO_SWIPE`, data => ({data}));
export const {
    action: fetchFeedItem,
    success: fetchFeedItemSuccess,
    failed: fetchFeedItemFailed,
} = createAction(`${domain}/UPDATE_FEED_ITEM`, feedItemId => ({feedItemId}));

export const {
    action: deleteSingle,
    success: deleteSingleSuccess,
    failed: deleteSingleFailed,
    aborted: deleteSingleAborted,
} = createAction(
    `${domain}/DELETE_SINGLE`,
    (originatorId, feedItemId, observationId, successUrl) => ({originatorId, feedItemId, observationId, successUrl}),
    (originatorId, feedItemId) => ({originatorId, feedItemId}),
);

export const {action: showingFeed} = createAction(`${domain}/SHOWING_FEED`, show => ({show}));

export const {action: focusMode, success: focusModeSuccess} = createAction(
    `${domain}/FOCUS_MODE`,
    isFocused => ({isFocused}),
    isFocused => ({isFocused}),
);

export const {
    action: blockSender,
    success: blockSenderSuccess,
    failed: blockSenderFailed,
} = createAction(`${domain}/BLOCK_SENDER`, (loginId, canUnsubscribeFromOrgSender) => ({
    loginId,
    canUnsubscribeFromOrgSender,
}));
